import { Subtitles } from "lucide-react";

const translations = {
  ar: {
    // Header
    title: "إدارة الإجراءات ",

    // Stats
    totalEmployees: "إجمالي الموظفين",
    promotionsThisMonth: "ترقيات هذا الشهر",
    transfersThisMonth: "نقل هذا الشهر",
    avgSalaryIncrease: "متوسط زيادة الراتب",
    pendingApprovals: "موافقات معلقة",
    completedActions: "إجراءات مكتملة",
    activeWorkforce: "القوى العاملة النشطة",
    careerGrowth: "النمو الوظيفي",
    departmentMoves: "تنقلات الأقسام",
    compensationGrowth: "نمو التعويض",
    awaitingReview: "في انتظار المراجعة",
    thisMonth: "هذا الشهر",
    fromYourTeam: "من فريقك",
    myTeam: "فريقي",
    selectDepartment: "اختر القسم",

    Subtitles: "إدارة إجراءات الموظفين وتنقلاتهم المهنية",
    // Filters & Search
    searchFilterEmployees: "البحث وتصفية الموظفين",
    showing: "عرض",
    of: "من",
    employees: "موظف",
    total: "الإجمالي",
    showMore: "عرض المزيد",
    forSelectedClient: "للعميل المحدد",
    viewHistory: "عرض السجل",
    refresh: "تحديث",
    searchEmployee: "البحث عن موظف",
    searchPlaceholder: "البحث بالاسم، الكود، الشركة، الوظيفة، الإيميل...",
    client: "العميل",
    allClients: "جميع العملاء",
    company: "الشركة",
    allCompanies: "جميع الشركات",
    selectCompany: "اختر الشركة...",
    department: "القسم",
    allDepartments: "جميع الأقسام",
    performance: "الأداء",
    allPerformanceLevels: "جميع مستويات الأداء",
    status: "الحالة",
    allStatuses: "جميع الحالات",
    sortBy: "الترتيب حسب",
    name: "الاسم",
    salary: "الراتب",
    joinDate: "تاريخ الانضمام",
    ascendingOrder: "ترتيب تصاعدي",
    descendingOrder: "ترتيب تنازلي",

    // Table
    employee: "الموظف",
    actions: "الإجراءات",
    loadingEmployees: "جاري تحميل الموظفين...",
    noEmployeesFound: "لم يتم العثور على موظفين",
    noEmployeesMatch: "لا يوجد موظفون يطابقون معايير البحث والتصفية الحالية.",
    pleaseWait: "يرجى الانتظار أثناء تحميل بيانات الموظفين...",
    clearFilters: "مسح التصفية",

    // Action Types
    selectActionType: "اختر نوع الإجراء",
    chooseAction: "اختر إجراءً للقيام به",
    promoteEmployee: "ترقية الموظف",
    demoteEmployee: "تخفيض رتبة الموظف",
    transferEmployee: "نقل الموظف",
    salaryAdjustment: "تعديل الراتب",
    terminateEmployment: "إنهاء الخدمة",
    resignationAction: "استقالة",
    resignationDescription: "تسجيل استقالة الموظف وآخر يوم عمل",
    suspendEmployee: "إيقاف الموظف",
    rehireEmployee: "إعادة توظيف الموظف",
    contractUpdate: "تحديث العقد",
    jobRotation: "التناوب الوظيفي",
    performanceReview: "تقييم الأداء",
    trainingAssignment: "تعيين تدريب",

    // Action Descriptions
    advanceToHigher: "ترقية الموظف لمنصب أعلى",
    moveToLower: "نقل الموظف لمنصب أقل",
    transferDifferent: "نقل إلى قسم مختلف",
    modifyCompensation: "تعديل تعويض الموظف",
    endEmployment: "إنهاء عقد العمل",
    temporarySuspension: "الإيقاف المؤقت عن العمل",
    reinstateFormer: "إعادة تعيين موظف سابق",
    modifyContract: "تعديل عقد العمل",
    rotateDifferent: "التناوب لدور/قسم مختلف",
    conductEvaluation: "إجراء تقييم الأداء",
    assignTraining: "تعيين برنامج تدريبي",

    // Approval Levels
    requiresHRManager: "يتطلب موافقة مدير الموارد البشرية",
    requiresDeptHead: "يتطلب موافقة رئيس القسم",
    requiresBothManagers: "يتطلب موافقة كلا المديرين",
    requiresFinanceManager: "يتطلب موافقة مدير المالية",
    requiresHRDirector: "يتطلب موافقة مدير الموارد البشرية",
    requiresLegal: "يتطلب موافقة القانوني",
    requiresDirectManager: "يتطلب موافقة المدير المباشر",
    requiresTrainingManager: "يتطلب موافقة مدير التدريب",

    // Form Fields - Common
    effectiveDate: "تاريخ السريان",
    reasonForAction: "سبب الإجراء",
    provideDetailedReason: "قدم سببًا تفصيليًا لهذا الإجراء...",
    approverNotes: "ملاحظات المعتمد",
    addAdditionalNotes: "أضف أي ملاحظات أو تعليقات إضافية...",
    approvalRequired: "الموافقة مطلوبة",
    thisActionRequires: "يتطلب هذا الإجراء موافقة من:",

    // Promote Fields
    newPosition: "المنصب الجديد",
    enterNewPosition: "أدخل عنوان المنصب الجديد...",
    newSalary: "الراتب الجديد",
    enterNewSalary: "أدخل مبلغ الراتب الجديد...",
    newDepartment: "القسم الجديد",
    keepCurrentDept: "الاحتفاظ بالقسم الحالي",
    currentSalary: "الحالي",
    newSalaryAmount: "جديد",

    // Demote Fields
    demotionReasonCategory: "فئة سبب التخفيض",
    selectReason: "اختر السبب",
    performanceIssues: "مشاكل في الأداء",
    companyRestructuring: "إعادة هيكلة الشركة",
    misconduct: "سوء السلوك",
    businessNeeds: "احتياجات العمل",
    other: "أخرى",

    // Transfer Fields
    keepCurrentPosition: "الاحتفاظ بالمنصب الحالي أو إدخال واحد جديد...",
    newManager: "المدير الجديد",
    transferType: "نوع النقل",
    selectType: "اختر النوع",
    permanentTransfer: "نقل دائم",
    temporaryTransfer: "نقل مؤقت",
    projectBased: "قائم على المشروع",

    // Salary Change Fields
    adjustmentType: "نوع التعديل",
    annualIncrease: "زيادة سنوية",
    promotion: "ترقية",
    marketAdjustment: "تعديل السوق",
    performanceBased: "قائم على الأداء",
    costOfLiving: "تكلفة المعيشة",
    salaryCorrection: "تصحيح الراتب",

    // Terminate Fields
    terminationType: "نوع الإنهاء",
    voluntaryResignation: "استقالة طوعية",
    involuntaryTermination: "إنهاء غير طوعي",
    retirement: "التقاعد",
    contractEnd: "نهاية العقد",
    mutualAgreement: "اتفاق متبادل",
    layoff: "تسريح العمال",
    lastWorkingDay: "آخر يوم عمل",
    terminationReason: "سبب الإنهاء",
    provideDetailedTermination: "قدم سبب الإنهاء التفصيلي...",
    severancePackage: "حزمة الفصل",
    enterSeveranceAmount: "أدخل مبلغ الفصل إذا كان ذلك منطبقًا...",
    eligibleForRehire: "مؤهل لإعادة التوظيف؟",
    yes: "نعم",
    no: "لا",
    conditional: "مشروط",
    showMore: "عرض المزيد",
    remaining: "متبقي",

    // Suspend Fields
    suspensionStartDate: "تاريخ بدء الإيقاف",
    suspensionEndDate: "تاريخ انتهاء الإيقاف",
    suspensionType: "نوع الإيقاف",
    withPay: "مع الراتب",
    withoutPay: "بدون راتب",
    partialPay: "راتب جزئي",
    suspensionReason: "سبب الإيقاف",
    provideDetailedSuspension: "قدم سبب الإيقاف التفصيلي...",

    // Rehire Fields
    position: "المنصب",
    enterPositionTitle: "أدخل عنوان المنصب...",
    startingSalary: "الراتب الابتدائي",
    enterStartingSalary: "أدخل الراتب الابتدائي...",
    rehireDate: "تاريخ إعادة التوظيف",

    // Contract Fields
    contractType: "نوع العقد",
    selectContractType: "اختر نوع العقد",
    permanent: "دائم",
    fixedTerm: "محدد المدة",
    temporary: "مؤقت",
    partTime: "دوام جزئي",
    consultant: "استشاري",
    contractor: "متعاقد",
    contractStartDate: "تاريخ بداية العقد",
    contractEndDate: "تاريخ انتهاء العقد",
    contractTerms: "شروط العقد",
    enterContractTerms: "أدخل أي شروط أو أحكام خاصة بالعقد...",

    // Rotation Fields
    rotationDepartment: "قسم التناوب",
    rotationRole: "دور التناوب",
    enterRotationRole: "أدخل دور التناوب...",
    durationMonths: "المدة (أشهر)",
    enterDuration: "أدخل المدة بالأشهر...",
    rotationObjectives: "أهداف التناوب",
    enterObjectives: "أدخل أهداف وغايات التعلم...",

    // Review Fields
    performanceRating: "تقييم الأداء",
    selectRating: "اختر التقييم",
    excellent: "ممتاز",
    veryGood: "جيد جدًا",
    good: "جيد",
    average: "متوسط",
    belowAverage: "دون المتوسط",
    poor: "ضعيف",
    reviewScore: "درجة التقييم (1-10)",
    enterScore: "أدخل الدرجة...",
    strengths: "نقاط القوة",
    listStrengths: "قائمة بنقاط القوة والإنجازات للموظف...",
    areasForImprovement: "مجالات التحسين",
    listImprovements: "قائمة بالمجالات التي تحتاج إلى تحسين...",
    nextReviewDate: "تاريخ المراجعة التالي",

    // Training Fields
    trainingProgram: "برنامج التدريب",
    enterTrainingProgram: "أدخل اسم برنامج التدريب...",
    trainingStartDate: "تاريخ بدء التدريب",
    trainingEndDate: "تاريخ انتهاء التدريب",
    trainingCost: "تكلفة التدريب",
    enterTrainingCost: "أدخل تكلفة التدريب...",
    trainingObjectives: "أهداف التدريب",
    enterTrainingObjectives: "أدخل أهداف ونتائج التدريب المتوقعة...",
    selectClient: "اختر عميل...",
    selectPerformance: "اختر الأداء...",
    selectStatus: "اختر الحالة...",

    // Modal Actions
    selectAction: "اختر إجراءً",
    selectActionToProceed:
      "اختر نوع إجراء من القائمة المنسدلة أعلاه للمتابعة مع إدارة الموظف",
    employeeAction: "إجراء الموظف",
    employeeName: "اسم الموظف",
    infinityCode: "رقم Infinity",
    currentPosition: "المنصب الحالي",
    currentDepartment: "القسم الحالي",
    reportsTo: "يرفع تقاريره إلى",
    cancel: "إلغاء",
    submitAction: "إرسال الإجراء",
    employeeHistory: "سجل الموظف",
    filtersActions: "الفلاتر والإجراءات",
    code: "الكود",
    directManager: "المدير المباشر",
    back: "رجوع",
    next: "التالي",
    reviewStep: "مراجعة",
    chooseActionStep: "اختيار الإجراء",
    detailsStep: "التفاصيل",
    chooseActionTitle: "ما الإجراء الذي تريد تنفيذه؟",
    chooseActionHint: "اختر نوع الإجراء، وبعدها املأ التفاصيل وراجعها قبل الإرسال.",
    changeAction: "تغيير",
    approvalPath: "مسار الموافقة",
    pendingFilterAll: "كل الطلبات",
    historyAll: "الكل",
    allActionTypes: "كل أنواع الإجراءات",
    historySearch: "ابحث بالاسم أو الكود أو السبب...",
    approvedBy: "تمت الموافقة بواسطة",
    rejectionReason: "سبب الرفض",
    otherDetails: "تفاصيل أخرى",
    pendingFilterMine: "في انتظاري",
    pendingSearch: "ابحث بالاسم أو الكود...",
    yourTurn: "دورك للموافقة",
    adminOverride: "تجاوز المشرف",
    currentStep: "الخطوة الحالية",
    close: "إغلاق",
    reasonAndNotes: "السبب والملاحظات",
    jobInfo: "بيانات الوظيفة",
    currentSalaryTitle: "الراتب الحالي",
    changesTitle: "التغييرات",
    noApprovalNeeded: "يُنفَّذ مباشرة بدون موافقات",
    noActionsAllowed: "ليس لديك صلاحية لتنفيذ أي إجراء على هذا الموظف.",

    // Confirmation Modal
    confirmAction: "تأكيد الإجراء",
    reviewBeforeConfirm: "يرجى مراجعة التفاصيل قبل تأكيد هذا الإجراء",
    actionDetails: "تفاصيل الإجراء",
    actionType: "نوع الإجراء",
    reason: "السبب",
    confirmSubmit: "تأكيد وإرسال",
    processing: "جاري المعالجة...",

    // History Modal
    actionHistory: "سجل الإجراءات",
    date: "التاريخ",
    details: "التفاصيل",
    noActionHistory: "لا يوجد سجل إجراءات",
    noActionsRecorded:
      "لم يتم تسجيل أي إجراءات موظفين بعد. ابدأ باتخاذ إجراء على موظف.",
    noDetailsProvided: "لم يتم توفير تفاصيل",

    // Pending Approvals Modal
    pendingApprovalsTitle: "الموافقات المعلقة",
    actionsAwaiting: "إجراء في انتظار الموافقة",
    requestedDate: "تاريخ الطلب",
    approvalLevel: "مستوى الموافقة",
    currentStepLabel: "الخطوة الحالية",
    stepOfLabel: "من",
    fullChainLabel: "سلسلة الموافقات الكاملة",
    approve: "موافقة",
    reject: "رفض",
    noPendingApprovals: "لا توجد موافقات معلقة",
    allActionsReviewed:
      "تمت مراجعة جميع الإجراءات. لا توجد موافقات معلقة في هذا الوقت.",

    // Employee History Modal
    employeeHistoryTitle: "سجل الموظف",
    currentInfo: "المعلومات الحالية",
    actionTimeline: "الجدول الزمني للإجراءات",
    records: "سجلات",
    noHistoryFound: "لم يتم العثور على سجل",
    noActionsForEmployee: "لم يتم تسجيل أي إجراءات لهذا الموظف بعد.",

    // Statuses
    pending: "معلق",
    approved: "موافق عليه",
    rejected: "مرفوض",
    completed: "مكتمل",
    unknown: "غير معروف",

    // Messages
    successActionApproved: "تمت الموافقة على الإجراء بنجاح",
    successActionRejected: "تم رفض الإجراء بنجاح",
    errorApprovingAction: "فشل الموافقة على الإجراء. يرجى المحاولة مرة أخرى.",
    errorRejectingAction: "فشل رفض الإجراء. يرجى المحاولة مرة أخرى.",
    errorLoadingEmployees: "فشل تحميل الموظفين. يرجى المحاولة مرة أخرى.",
    pleaseSelectAction: "يرجى اختيار نوع إجراء",
    effectiveDateRequired: "تاريخ السريان مطلوب",
    reasonRequired: "سبب الإجراء مطلوب",
    approverNotesRequired: "ملاحظات المعتمد مطلوبة",
    actionSubmittedSuccess: "تم إرسال الإجراء بنجاح",
    awaitingApproval: "في انتظار الموافقة",
    salaryWillIncrease: "سيزداد الراتب بمقدار",
    salaryWillDecrease: "سينخفض الراتب بمقدار",
    changesAppliedOnApproval:
      "سيتم تطبيق التغييرات على سجل الموظف والرواتب عند الموافقة.",
    changesAppliedImmediately:
      "سيتم تطبيق التغييرات على سجل الموظف والرواتب فورًا.",
    errorProcessingAction: "خطأ في معالجة الإجراء.",
    pleaseTryAgain: "يرجى المحاولة مرة أخرى أو الاتصال بالدعم.",

    // Misc
    notAvailable: "غير متوفر",
    egp: "ج.م",
    searchForManagers: "البحث عن المدراء...",
    noManagersFound: "لم يتم العثور على مدراء",
    tryDifferentSearch: "جرب مصطلح بحث مختلف",
    noManagersAvailable: "لا يوجد مدراء متاحون",
  },
  en: {
    // Header
    title: "Employee Actions & Management",

    // Stats
    totalEmployees: "Total Employees",
    promotionsThisMonth: "Promotions This Month",
    transfersThisMonth: "Transfers This Month",
    avgSalaryIncrease: "Avg. Salary Increase",
    pendingApprovals: "Pending Approvals",
    completedActions: "Completed Actions",
    activeWorkforce: "Active workforce",
    careerGrowth: "Career growth",
    departmentMoves: "Department moves",
    compensationGrowth: "Compensation growth",
    awaitingReview: "Awaiting review",
    thisMonth: "This month",
    selectClient: "Select Client...",
    selectDepartment: "Select Department...",
    selectPerformance: "Select Performance...",
    selectStatus: "Select Status...",
    Subtitles: "Manage employee actions and career movements",

    // Filters & Search
    searchFilterEmployees: "Search & Filter Employees",
    showing: "Showing",
    of: "of",
    employees: "employees",
    total: "total",
    showMore: "Show more",
    forSelectedClient: "for selected client",
    viewHistory: "View History",
    refresh: "Refresh",
    searchEmployee: "Search Employee",
    searchPlaceholder: "Search by name, code, company, position, email...",
    client: "Client",
    allClients: "All Clients",
    company: "Company",
    allCompanies: "All Companies",
    selectCompany: "Select Company...",
    department: "Department",
    allDepartments: "All Departments",
    performance: "Performance",
    allPerformanceLevels: "All Performance Levels",
    status: "Status",
    allStatuses: "All Statuses",
    sortBy: "Sort By",
    name: "Name",
    salary: "Salary",
    joinDate: "Join Date",
    ascendingOrder: "Ascending order",
    descendingOrder: "Descending order",

    // Table
    employee: "Employee",
    actions: "Actions",
    loadingEmployees: "Loading employees...",
    noEmployeesFound: "No Employees Found",
    noEmployeesMatch:
      "No employees match your current search and filter criteria.",
    pleaseWait: "Please wait while we load the employee data...",
    clearFilters: "Clear Filters",

    // Action Types
    selectActionType: "Select Action Type",
    chooseAction: "Choose an action to perform",
    promoteEmployee: "Promote Employee",
    demoteEmployee: "Demote Employee",
    transferEmployee: "Transfer Employee",
    salaryAdjustment: "Salary Adjustment",
    terminateEmployment: "Terminate Employment",
    resignationAction: "Resignation",
    resignationDescription: "Record an employee's resignation and last working day",
    suspendEmployee: "Suspend Employee",
    rehireEmployee: "Rehire Employee",
    contractUpdate: "Contract Update",
    jobRotation: "Job Rotation",
    performanceReview: "Performance Review",
    trainingAssignment: "Training Assignment",

    // Action Descriptions
    advanceToHigher: "Advance employee to higher position",
    moveToLower: "Move employee to lower position",
    transferDifferent: "Transfer to different department",
    modifyCompensation: "Modify employee compensation",
    endEmployment: "End employment contract",
    temporarySuspension: "Temporary suspension from duties",
    reinstateFormer: "Reinstate former employee",
    modifyContract: "Modify employment contract",
    rotateDifferent: "Rotate to different role/department",
    conductEvaluation: "Conduct performance evaluation",
    assignTraining: "Assign to training program",

    // Approval Levels
    requiresHRManager: "Requires HR Manager approval",
    requiresDeptHead: "Requires Department Head approval",
    requiresBothManagers: "Requires Both Managers approval",
    requiresFinanceManager: "Requires Finance Manager approval",
    requiresHRDirector: "Requires HR Director approval",
    requiresLegal: "Requires Legal Department approval",
    requiresDirectManager: "Requires Direct Manager approval",
    requiresTrainingManager: "Requires Training Manager approval",

    // Form Fields - Common
    effectiveDate: "Effective Date",
    reasonForAction: "Reason for Action",
    provideDetailedReason: "Provide detailed reason for this action...",
    approverNotes: "Approver Notes",
    addAdditionalNotes: "Add any additional notes or comments...",
    approvalRequired: "Approval Required",
    thisActionRequires: "This action requires approval from:",

    // Promote Fields
    newPosition: "New Position",
    enterNewPosition: "Enter new position title...",
    newSalary: "New Salary",
    enterNewSalary: "Enter new salary amount...",
    newDepartment: "New Department",
    keepCurrentDept: "Keep Current Department",
    currentSalary: "Current",
    newSalaryAmount: "New",

    // Demote Fields
    demotionReasonCategory: "Demotion Reason Category",
    selectReason: "Select Reason",
    performanceIssues: "Performance Issues",
    companyRestructuring: "Company Restructuring",
    misconduct: "Misconduct",
    businessNeeds: "Business Needs",
    other: "Other",

    // Transfer Fields
    selectDepartment: "Select Department",
    keepCurrentPosition: "Keep current position or enter new one...",
    newManager: "New Manager",
    transferType: "Transfer Type",
    selectType: "Select Type",
    permanentTransfer: "Permanent Transfer",
    temporaryTransfer: "Temporary Transfer",
    projectBased: "Project-Based",

    // Salary Change Fields
    adjustmentType: "Adjustment Type",
    annualIncrease: "Annual Increase",
    promotion: "Promotion",
    marketAdjustment: "Market Adjustment",
    performanceBased: "Performance-Based",
    costOfLiving: "Cost of Living",
    salaryCorrection: "Salary Correction",

    // Terminate Fields
    terminationType: "Termination Type",
    voluntaryResignation: "Voluntary Resignation",
    involuntaryTermination: "Involuntary Termination",
    retirement: "Retirement",
    contractEnd: "Contract End",
    mutualAgreement: "Mutual Agreement",
    layoff: "Layoff/Redundancy",
    lastWorkingDay: "Last Working Day",
    terminationReason: "Termination Reason",
    provideDetailedTermination: "Provide detailed termination reason...",
    severancePackage: "Severance Package",
    enterSeveranceAmount: "Enter severance amount if applicable...",
    eligibleForRehire: "Eligible for Rehire?",
    yes: "Yes",
    no: "No",
    conditional: "Conditional",

    // Suspend Fields
    suspensionStartDate: "Suspension Start Date",
    suspensionEndDate: "Suspension End Date",
    suspensionType: "Suspension Type",
    withPay: "With Pay",
    withoutPay: "Without Pay",
    partialPay: "Partial Pay",
    suspensionReason: "Suspension Reason",
    provideDetailedSuspension: "Provide detailed suspension reason...",

    // Rehire Fields
    position: "Position",
    enterPositionTitle: "Enter position title...",
    startingSalary: "Starting Salary",
    enterStartingSalary: "Enter starting salary...",
    rehireDate: "Rehire Date",

    // Contract Fields
    contractType: "Contract Type",
    selectContractType: "Select Contract Type",
    permanent: "Permanent",
    fixedTerm: "Fixed Term",
    temporary: "Temporary",
    partTime: "Part Time",
    consultant: "Consultant",
    contractor: "Contractor",
    contractStartDate: "Contract Start Date",
    contractEndDate: "Contract End Date",
    contractTerms: "Contract Terms",
    enterContractTerms: "Enter any special contract terms or conditions...",

    // Rotation Fields
    rotationDepartment: "Rotation Department",
    rotationRole: "Rotation Role",
    enterRotationRole: "Enter rotation role...",
    durationMonths: "Duration (months)",
    enterDuration: "Enter duration in months...",
    rotationObjectives: "Rotation Objectives",
    enterObjectives: "Enter learning objectives and goals...",

    // Review Fields
    performanceRating: "Performance Rating",
    selectRating: "Select Rating",
    excellent: "Excellent",
    veryGood: "Very Good",
    good: "Good",
    average: "Average",
    belowAverage: "Below Average",
    poor: "Poor",
    reviewScore: "Review Score (1-10)",
    enterScore: "Enter score...",
    strengths: "Strengths",
    listStrengths: "List employee strengths and achievements...",
    areasForImprovement: "Areas for Improvement",
    listImprovements: "List areas that need improvement...",
    nextReviewDate: "Next Review Date",
    fromYourTeam: "from your team",
    myTeam: "My Team",

    // Training Fields
    trainingProgram: "Training Program",
    enterTrainingProgram: "Enter training program name...",
    trainingStartDate: "Training Start Date",
    trainingEndDate: "Training End Date",
    trainingCost: "Training Cost",
    enterTrainingCost: "Enter training cost...",
    trainingObjectives: "Training Objectives",
    enterTrainingObjectives:
      "Enter training objectives and expected outcomes...",

    // Modal Actions
    selectAction: "Select an Action",
    selectActionToProceed:
      "Choose an action type from the dropdown above to proceed with employee management",
    employeeAction: "Employee Action",
    employeeName: "Employee Name",
    infinityCode: "Infinity Code",
    currentPosition: "Current Position",
    currentDepartment: "Current Department",
    reportsTo: "Reports To",
    cancel: "Cancel",
    submitAction: "Submit Action",
    employeeHistory: "Employee History",
    filtersActions: "Filters & Actions",
    code: "Code",
    directManager: "Direct Manager",
    back: "Back",
    next: "Next",
    reviewStep: "Review",
    chooseActionStep: "Choose action",
    detailsStep: "Details",
    chooseActionTitle: "What would you like to do?",
    chooseActionHint: "Pick an action type, then fill in the details and review them before submitting.",
    changeAction: "Change",
    approvalPath: "Approval path",
    pendingFilterAll: "All requests",
    historyAll: "All",
    allActionTypes: "All action types",
    historySearch: "Search by name, code or reason...",
    approvedBy: "Approved by",
    rejectionReason: "Rejection reason",
    otherDetails: "Other details",
    pendingFilterMine: "Awaiting me",
    pendingSearch: "Search by name or code...",
    yourTurn: "Your turn",
    adminOverride: "Admin override",
    currentStep: "Current step",
    close: "Close",
    reasonAndNotes: "Reason & notes",
    jobInfo: "Job details",
    currentSalaryTitle: "Current salary",
    changesTitle: "Changes",
    noApprovalNeeded: "Applied directly, no approvals needed",
    noActionsAllowed: "You don't have permission to perform any action on this employee.",
    showMore: "Show More",
    remaining: "remaining",

    // Confirmation Modal
    confirmAction: "Confirm Action",
    reviewBeforeConfirm:
      "Please review the details before confirming this action",
    actionDetails: "Action Details",
    actionType: "Action Type",
    reason: "Reason",
    confirmSubmit: "Confirm & Submit",
    processing: "Processing...",

    // History Modal
    actionHistory: "Action History",
    date: "Date",
    details: "Details",
    noActionHistory: "No Action History",
    noActionsRecorded:
      "No employee actions have been recorded yet. Start by taking an action on an employee.",
    noDetailsProvided: "No details provided",

    // Pending Approvals Modal
    pendingApprovalsTitle: "Pending Approvals",
    actionsAwaiting: "actions awaiting approval",
    requestedDate: "Requested Date",
    approvalLevel: "Approval Level",
    currentStepLabel: "Current step",
    stepOfLabel: "of",
    fullChainLabel: "Full approval chain",
    approve: "Approve",
    reject: "Reject",
    noPendingApprovals: "No Pending Approvals",
    allActionsReviewed:
      "All actions have been reviewed. There are no pending approvals at this time.",

    // Employee History Modal
    employeeHistoryTitle: "Employee History",
    currentInfo: "Current Information",
    actionTimeline: "Action Timeline",
    records: "records",
    noHistoryFound: "No History Found",
    noActionsForEmployee:
      "No actions have been recorded for this employee yet.",

    // Statuses
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    unknown: "Unknown",

    // Messages
    successActionApproved: "Action approved successfully",
    successActionRejected: "Action rejected successfully",
    errorApprovingAction: "Failed to approve action. Please try again.",
    errorRejectingAction: "Failed to reject action. Please try again.",
    errorLoadingEmployees: "Failed to load employees. Please try again.",
    pleaseSelectAction: "Please select an action type",
    effectiveDateRequired: "Effective date is required",
    reasonRequired: "Reason for action is required",
    approverNotesRequired: "Approver notes are required",
    actionSubmittedSuccess: "successfully submitted for",
    awaitingApproval: "Awaiting approval",
    salaryWillIncrease: "Salary will increase by EGP",
    salaryWillDecrease: "Salary will decrease by EGP",
    changesAppliedOnApproval:
      "Changes will be applied to employee record and payroll upon approval.",
    changesAppliedImmediately:
      "Changes will be applied to employee record and payroll immediately.",
    errorProcessingAction: "Error processing action.",
    pleaseTryAgain: "Please try again or contact support.",

    // Misc
    notAvailable: "N/A",
    egp: "EGP",
    searchForManagers: "Search for managers...",
    noManagersFound: "No managers found",
    tryDifferentSearch: "Try a different search term",
    noManagersAvailable: "No managers available",
  },
};

export default translations;